import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import BlockedRequestsData from "./blocked-requests-data/index";
import ET3PageDiv from "../../../core/et3-page-div";
import BlockedRequestsForm from "./blocked-requests-form";

const BlockedRequests = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_BLOCKED_REQUESTS",
      "DEVELOPER_BLOCKED_REQUESTS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("BLOCKED_REQUESTS")}
        subTitle={i18n.get("BLOCKED_REQUESTS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <BlockedRequestsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <BlockedRequestsData />
    </ET3PageDiv>
  );
});

export default BlockedRequests;
